<template>
    <div class="admin-footer">
        <div class="loading-container" style="display: none;">
            <div class="loading">
                <img src="/static/images/loading.gif">
            </div>
        </div>
        © {{footerSystemYear}} Velocity Vehicle Group. All Rights Reserved. 
    </div>
</template>

<script>
    var self;
    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "Footer",
        mixins: [commonMixins],
        data: () => ({
                footerSystemYear: "2019",
                role: "",
            }),
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            this.initMenu();
            //self.getUserPermissions();
            var path = window.location.pathname;
            var pathArr = path.split("/");
            var customerExp = /^customer$/;
            var dashboardExp = /^dashboard$/;
            /* setTimeout(function () {
                $("#menu li").removeClass("active")
                //main manus
                if (customerExp.test(pathArr[1])) {
                    $("#customerLink").addClass('active');
                }
                if (dashboardExp.test(pathArr[1])) {
                    $("#dashboardLink").addClass('active');
                }
                
            }, 1000); */
            //check user loggged in or not
            var userObj = localStorage.getItem("user_obj");
            self.footerSystemYear = localStorage.getItem("systemYear");
            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                /* if (userJson.roles.length > 0) {
                    this.role = userJson.roles[0].name;
                } */
                EventBus.$emit("logged-in", true, userJson["first_name"], userJson["last_name"], userJson["username"], userJson["username"]);
                /* Get Role for conditionally provide add/edit feature */
            }
            /* $("#menu-toggle").unbind().click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").unbind().click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            }); */
        },
        methods: {
            //to open submenu and
            initMenu: function () {
                $('#menu ul').hide();
                $('#menu ul').children('.current').parent().show();
                // $('#menu ul:first').show();
                $('#menu li a').click(
                    function () {
                        var checkElement = $(this).next();
                        if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                            return false;
                        }
                        if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                            $('#menu ul:visible').slideUp('normal');
                            checkElement.slideDown('normal');
                            return false;
                        }
                    }
                );
            },
        }
    };
    EventBus.$on('systemYear', function (isLogin, systemYear) {
        self.footerSystemYear = systemYear;
    });
</script>